import {
    ColoursObj,
    Gutters,
    MainButton,
    MobileConfirmDialog,
    TDialogStore,
    useDialogStore,
} from '@eventr/common-storybook'
import { Divider, Stack } from '@mui/material'
import { useShallow } from 'zustand/react/shallow'
import i18n from '../../../i18n/i18next'
import { NavigationView } from '../../layout/NavigationView'
import { ToolbarItemProps } from '../../layout/TopToolbar'

interface IBaseBookingItemPageProps {
    children: React.ReactNode
    headerText: string
    subHeaderText: string
    deleteButtonText?: string
    deleteAction?: () => void
    onReset?: () => void
    isDirty: boolean
    onSaveData?: () => void
}
export const BaseBookingItemPage = ({
    children,
    headerText,
    subHeaderText,
    deleteAction,
    isDirty,
    onSaveData,
    onReset,
    deleteButtonText = i18n.t('general.delete'),
}: IBaseBookingItemPageProps) => {
    const { replaceDialog, clearDialog }: TDialogStore = useDialogStore(
        useShallow((s: TDialogStore) => ({
            clearDialog: s.clearDialog,
            replaceDialog: s.replaceDialog,
        }))
    )

    // removes the element if its empty and the user goes back
    const removeElement = () => {
        onReset && onReset()
    }

    const onBackPressed = () => {
        if (isDirty) {
            replaceDialog({
                node: (
                    <MobileConfirmDialog
                        text="You have unsaved changes. Are you sure you want to leave this page?"
                        header="Unsaved Changes"
                        onConfirm={() => {
                            removeElement()
                            clearDialog()
                            window.goBack()
                        }}
                        onCancel={() => {
                            clearDialog()
                        }}
                    />
                ),
                backdropClosable: false,
            })
        } else {
            removeElement()
            window.goBack()
        }
    }

    function openDeleteDialog() {
        replaceDialog({
            node: (
                <MobileConfirmDialog
                    text="Are you sure you want to remove this Item ?"
                    header="Delete Item"
                    onCancel={() => {
                        clearDialog()
                    }}
                    onConfirm={onDelete}
                />
            ),
            backdropClosable: false,
        })
    }

    const onDelete = async () => {
        deleteAction()
        clearDialog()
        window.goBack()
    }

    const navigationBarTrailing = () => {
        const popoverItems = [] as ToolbarItemProps[]
        popoverItems.push({
            disabled: !isDirty,
            id: 'saveButton',
            buttonText: i18n.t('general.done'),
            colour: ColoursObj.core.primary,
            useButton: true,
            action: () => {
                onSaveData && onSaveData()
                window.goBack()
            },
        })

        return popoverItems
    }
    const backButton: ToolbarItemProps = {
        id: 'backButtonNavigation',
        buttonText: i18n.t('general.cancel'),
        useButton: true,
        colour: ColoursObj.core.primary,
        action: () => {
            onBackPressed()
        },
    }

    return (
        <>
            <NavigationView
                usePageTransition
                navigationBarTitle={headerText}
                navigationBarSubtitle={subHeaderText}
                navigationBarTrailing={navigationBarTrailing()}
                backButton={backButton}
                backButtonAction={onBackPressed}
                footer={
                    <Stack direction={'row'} justifyContent={'center'}>
                        {/* {!isNewItem(idSubItem) && ( */}
                        <MainButton
                            id={`delete-button`}
                            onClick={() => {
                                openDeleteDialog()
                            }}
                            variant="destructiveBorderless"
                        >
                            {deleteButtonText}
                        </MainButton>
                        {/* )} */}
                    </Stack>
                }
            >
                <Gutters>
                    <Stack gap={'16px'}>
                        <Stack spacing={'16px'}>
                            {children}

                            <Divider />
                        </Stack>
                    </Stack>
                </Gutters>
            </NavigationView>
        </>
    )
}
